import { createReducer, getUpdater } from '@advanza/advanza_generic'
import {
    ANALYTICS_CHANGE_FILTER,
    ANALYTICS_RECEIVE_LIST,
    ANALYTICS_REQUEST,
} from '../actions/analytics'
import { changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    [ANALYTICS_RECEIVE_LIST]: receiveList,
    [ANALYTICS_CHANGE_FILTER]: changeFilter,
    INVALIDATE_ANALYTICS: invalidateFilters,
    [ANALYTICS_REQUEST]: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    entities: {},
    result: {},
    counts: {},
    filters: {},
}

export default createReducer(initialState, handlers)
